import { useRef } from 'react'

import { useDisposableEffect } from './useDisposableEffect'

/**
 * Similar to useEffect hook, that just skips first run
 */
export const useOnChange = <T extends any[] | []>(cb: (stack: DisposableStack) => void | undefined, deps: T) => {
  const firstRun = useRef(true)
  useDisposableEffect(stack => {
    if (firstRun.current) {
      firstRun.current = false
      return
    }

    const cleanup = cb(stack)

    return cleanup
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
